/* Finish studio.

   The section ships the sellable variants as flat rows; this builds the lookup
   once, so changing finish or model is a map read and an image swap with nothing
   fetched. Rows carry MEDIA IDS, not URLs — the section emits the shared CDN
   prefix once and a table of id to filename, because a full URL per variant per
   image was ~59KB of near-identical strings on the homepage.

   ADDING TO CART WITHOUT A PRODUCT FORM. On the PDP the honest move was to press
   the theme's own Add to cart. There is no product form here, so this must post
   the add itself — the situation that broke the cart once already. Dispatching
   cart:update is not enough on its own, which cost a second round of the same
   bug: the item went in, the drawer opened, and it said the cart was empty. The
   drawer is markup rendered inside the header SECTION, so telling the page the
   cart changed does not rebuild it. Shopify will re-render it in the same
   request: ask /cart/add.js for the header section, swap the returned
   <cart-drawer-component> contents into the live one, then open it via open().
   The section id is read from the DOM because it is template-specific. */
(function () {
  'use strict';

  var root = document.querySelector('[data-sfs]');
  if (!root) return;

  var data;
  try { data = JSON.parse(root.querySelector('[data-sfs-data]').textContent); } catch (e) { return; }
  if (!data || !data.rows || !data.rows.length) return;

  /* Materials read from thin to substantial rather than alphabetically. */
  var MAT_ORDER = ['Clear', 'Frosted', 'NanoLeather', 'Silicone', 'NanoSuede', 'Carbon Fiber'];

  /* Filter entries that stand for more than one material. Clear and Frosted are
     the same acrylic — one polished, one diffused — and on their own Clear is a
     single finish, so the filter offered an option with one swatch behind it.
     Grouped, they read as one choice and the material grid's "Clear and Frosted"
     panel has something to land on. A group is emitted in place of its members,
     at the first member's position; drop this entry and the two split again. */
  var GROUPS = [
    { label: 'Clear & Frosted Clear', members: ['Clear', 'Frosted'] }
  ];

  /* An option's value is its materials joined by a pipe, so one option can stand
     for several. A single material is just its own name. */
  function inFilter(mat, want) {
    if (!want) return true;
    return ('|' + want + '|').indexOf('|' + mat + '|') !== -1;
  }

  var $ = function (s) { return root.querySelector(s); };
  var stage = $('.sfs__stage');
  var stageBg = $('[data-sfs-stagebg]');
  var img = $('[data-sfs-img]');
  var thumbs = $('[data-sfs-thumbs]');
  var nameOut = $('[data-sfs-name]');
  var priceOut = $('[data-sfs-price]');
  var descOut = $('[data-sfs-desc]');
  var matOut = $('[data-sfs-mat]');
  var selOut = $('[data-sfs-sel]');
  var countOut = $('[data-sfs-count]');
  var addBtn = $('[data-sfs-add]');
  var addLabel = $('[data-sfs-addlabel]');
  var filter = $('[data-sfs-filter]');
  var toast = $('[data-sfs-toast]');
  var toastText = $('[data-sfs-toasttext]');
  var CTA = addLabel ? addLabel.textContent.trim() : 'Add to cart';

  var BASE = data.base || '';
  var IMG = data.img || {};
  function urlFor(id, w) {
    var tail = IMG[String(id)];
    if (!tail) return '';
    var u = BASE + tail;
    return w ? u.replace(/([?&])width=\d+/, '$1width=' + w) : u;
  }

  /* ---------- button label ---------- */

  /* The PDP button reads label, hairline, price rather than joining the two with
     a dash, so this one is built from the same three parts. */
  var addLbl = null, addDiv = null, addPrice = null;
  if (addLabel) {
    addLabel.classList.add('sfs__addtext');
    addLabel.textContent = '';
    addLbl = document.createElement('span');
    addLbl.textContent = CTA;
    addDiv = document.createElement('span');
    addDiv.className = 'sfs__adddiv';
    addDiv.setAttribute('aria-hidden', 'true');
    addPrice = document.createElement('span');
    addLabel.appendChild(addLbl);
    addLabel.appendChild(addDiv);
    addLabel.appendChild(addPrice);
  }

  function setAdd(text, price) {
    if (!addLabel) return;
    addLbl.textContent = text;
    addPrice.textContent = price || '';
    addDiv.hidden = !price;
  }

  /* ---------- lookup ---------- */

  var byColour = {};
  data.rows.forEach(function (r) {
    if (!byColour[r[0]]) byColour[r[0]] = {};
    byColour[r[0]][r[1]] = { id: r[2], price: r[3], priceFull: r[4], media: r[5] || [] };
  });

  var swatches = [].slice.call(root.querySelectorAll('[data-sfs-sw]'));
  var models = [].slice.call(root.querySelectorAll('[data-sfs-model]'));
  var matOf = {};

  swatches = swatches.filter(function (b) {
    var n = b.getAttribute('data-sfs-sw');
    if (!byColour[n]) { b.remove(); return false; }
    matOf[n] = b.getAttribute('data-mat') || '';
    return true;
  });
  if (!swatches.length) return;

  var present = [];
  swatches.forEach(function (b) {
    var m = matOf[b.getAttribute('data-sfs-sw')];
    if (m && present.indexOf(m) === -1) present.push(m);
  });

  function groupOf(m) {
    for (var i = 0; i < GROUPS.length; i++) {
      if (GROUPS[i].members.indexOf(m) !== -1) return GROUPS[i];
    }
    return null;
  }

  var ordered = MAT_ORDER.filter(function (m) { return present.indexOf(m) !== -1; })
    .concat(present.filter(function (m) { return MAT_ORDER.indexOf(m) === -1; }));

  var emitted = [];
  ordered.forEach(function (m) {
    var g = groupOf(m);
    var mem = g ? g.members.filter(function (x) { return present.indexOf(x) !== -1; }) : null;
    /* A group with only one of its members in stock is just that material. */
    var grouped = mem && mem.length > 1;
    var value = grouped ? mem.join('|') : m;
    if (emitted.indexOf(value) !== -1) return;
    emitted.push(value);
    var o = document.createElement('option');
    o.value = value;
    o.textContent = grouped ? g.label : m;
    filter.appendChild(o);
  });

  var wanted = root.getAttribute('data-open') || '';
  var colour = byColour[wanted] ? wanted : swatches[0].getAttribute('data-sfs-sw');
  var model = null;
  var shot = 0;
  var current = [];

  function modelsFor(c) {
    return models.filter(function (b) { return !!byColour[c][b.getAttribute('data-sfs-model')]; });
  }

  /* Wraps, so neither the arrows nor a swipe ever dead-ends on the last shot. */
  function step(d) {
    if (current.length < 2) return;
    shot = (shot + d + current.length) % current.length;
    render();
  }

  /* ---------- arrows ---------- */

  /* Built here rather than in the section: the whole gallery is JS-driven, and a
     control that does nothing without JS should not ship in the markup. */
  var prevBtn = null, nextBtn = null;
  if (stage) {
    var CHEV = '<svg class="sfs__navicon" viewBox="0 0 11 19" aria-hidden="true">' +
      '<path d="M9.5 1.5l-8 8 8 8" fill="none" stroke="currentColor" stroke-width="1.6"' +
      ' stroke-linecap="round" stroke-linejoin="round"/></svg>';
    prevBtn = document.createElement('button');
    prevBtn.type = 'button';
    prevBtn.className = 'sfs__nav sfs__nav--prev';
    prevBtn.setAttribute('aria-label', 'Previous image');
    prevBtn.innerHTML = CHEV;
    nextBtn = prevBtn.cloneNode(true);
    nextBtn.className = 'sfs__nav sfs__nav--next';
    nextBtn.setAttribute('aria-label', 'Next image');
    stage.appendChild(prevBtn);
    stage.appendChild(nextBtn);
    prevBtn.addEventListener('click', function () { step(-1); });
    nextBtn.addEventListener('click', function () { step(1); });
  }

  /* ---------- swipe ---------- */

  /* touch-action: pan-y pinch-zoom on the stage hands horizontal gestures to us
     and leaves vertical scrolling and pinching to the browser, so none of this
     calls preventDefault and fights the page — which also means the listeners
     stay passive.

     The first 8px of movement decide whether the gesture is ours or the page's,
     and once it is the page's this bows out for the rest of the gesture. The
     image tracks the finger at a third of the distance: enough to feel answered,
     not so much that a hesitant drag looks broken when it snaps back. */
  if (stage && img) {
    var sx = 0, sy = 0, dx = 0, dragging = false, decided = false, horiz = false;

    stage.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1 || current.length < 2) return;
      sx = e.touches[0].clientX;
      sy = e.touches[0].clientY;
      dx = 0; dragging = true; decided = false; horiz = false;
      img.style.transition = 'none';
    }, { passive: true });

    stage.addEventListener('touchmove', function (e) {
      if (!dragging || e.touches.length !== 1) return;
      dx = e.touches[0].clientX - sx;
      var dy = e.touches[0].clientY - sy;
      if (!decided && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) {
        decided = true;
        horiz = Math.abs(dx) > Math.abs(dy);
        if (!horiz) { endDrag(); return; }
      }
      if (horiz) img.style.transform = 'translateX(' + (dx * 0.33) + 'px)';
    }, { passive: true });

    function endDrag() {
      if (!dragging) return;
      dragging = false;
      img.style.transition = '';
      img.style.transform = '';
      if (horiz && Math.abs(dx) > 40) step(dx < 0 ? 1 : -1);
    }

    stage.addEventListener('touchend', endDrag, { passive: true });
    stage.addEventListener('touchcancel', endDrag, { passive: true });
  }

  /* ---------- image ---------- */

  /* Almost every image on this product is square, and a square photo fills the
     square stage edge to edge. Clear is the exception: its four lifestyle shots
     are 4:5, so object-fit leaves the section's cream showing down both sides
     and the photo reads as a box floating inside the column. Cropping them to
     square cuts the bottom off the phone, so instead the same image is blurred
     and scaled behind it. The photo's own edges are flat studio grey, so what
     fills the gap is that grey — the seam does not read.

     Only for images that are actually off-square. The renders are square AND
     transparent, and a blurred copy behind one would show straight through it. */
  function fitBackdrop(w, h, src) {
    if (!stageBg) return;
    var offSquare = w && h && Math.abs(w / h - 1) > 0.02;
    if (offSquare) {
      stageBg.style.backgroundImage = 'url("' + src + '")';
      stageBg.classList.add('is-on');
    } else {
      stageBg.classList.remove('is-on');
      stageBg.style.backgroundImage = '';
    }
  }

  var token = 0;
  function setImage(src, alt) {
    if (!img || !src || img.getAttribute('src') === src) return;
    var mine = ++token;
    var swapped = false;
    function swap() {
      if (swapped || mine !== token) return;
      swapped = true;
      img.src = src;
      img.alt = alt || '';
      img.classList.remove('is-fading');
      fitBackdrop(pre.naturalWidth, pre.naturalHeight, src);
      /* The deadline below can fire before the preload has settled, in which
         case there are no dimensions yet — ask again once the real image has
         them. */
      img.addEventListener('load', function onl() {
        img.removeEventListener('load', onl);
        if (mine === token) fitBackdrop(img.naturalWidth, img.naturalHeight, src);
      });
    }
    img.classList.add('is-fading');
    var pre = new Image();
    var loaded = false, elapsed = false;
    pre.onload = pre.onerror = function () { loaded = true; if (elapsed) swap(); };
    pre.src = src;
    if (pre.complete) loaded = true;
    setTimeout(function () { elapsed = true; if (loaded) swap(); }, 150);
    /* Never leave the stage blank waiting on a load that may not settle. */
    setTimeout(swap, 700);
  }

  /* ---------- thumbnails ---------- */

  /* Rebuilt only when the SET of images changes, never on a plain selection
     change. The strip is a horizontal scroller on a phone, and rebuilding it
     would send it back to the first thumbnail every time — exactly when someone
     has scrolled to the end to reach the shot they want. */
  var thumbKey = '';

  function keepThumbVisible() {
    if (!thumbs || thumbs.hidden) return;
    var on = thumbs.children[shot];
    if (!on || thumbs.scrollWidth <= thumbs.clientWidth) return;
    var left = on.offsetLeft;
    var right = left + on.offsetWidth;
    /* Scrolls the strip only, never the page. */
    if (left < thumbs.scrollLeft + 8) {
      thumbs.scrollTo({ left: Math.max(0, left - 8), behavior: 'smooth' });
    } else if (right > thumbs.scrollLeft + thumbs.clientWidth - 8) {
      thumbs.scrollTo({ left: right - thumbs.clientWidth + 8, behavior: 'smooth' });
    }
  }

  /* A one-image gallery is not a gallery — several of the legacy colours have a
     single shot, and a lone thumbnail under the stage reads as a mistake. */
  function renderThumbs(media) {
    if (!thumbs) return;
    if (!media || media.length < 2) {
      thumbs.hidden = true;
      thumbs.innerHTML = '';
      thumbKey = '';
      return;
    }

    var key = media.join(',');
    if (key !== thumbKey) {
      thumbKey = key;
      thumbs.innerHTML = '';
      media.forEach(function (id, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'sfs__thumb';
        b.setAttribute('data-sfs-thumb', String(i));
        b.setAttribute('aria-label', 'Image ' + (i + 1) + ' of ' + media.length);
        var t = document.createElement('img');
        t.src = urlFor(id, 160);
        t.alt = '';
        t.loading = 'lazy';
        t.decoding = 'async';
        b.appendChild(t);
        thumbs.appendChild(b);
      });
      thumbs.scrollLeft = 0;
    }

    thumbs.hidden = false;
    [].forEach.call(thumbs.children, function (b, i) {
      b.classList.toggle('is-on', i === shot);
      b.setAttribute('aria-pressed', i === shot ? 'true' : 'false');
    });
    keepThumbVisible();
  }

  /* ---------- render ---------- */

  function render() {
    var avail = byColour[colour];
    if (!model || !avail[model]) {
      var firstOk = modelsFor(colour)[0];
      model = firstOk ? firstOk.getAttribute('data-sfs-model') : null;
    }

    swatches.forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-sfs-sw') === colour ? 'true' : 'false');
    });

    models.forEach(function (b) {
      var m = b.getAttribute('data-sfs-model');
      var ok = !!avail[m];
      b.disabled = !ok;
      b.setAttribute('aria-pressed', ok && m === model ? 'true' : 'false');
      b.title = ok ? '' : colour + ' is not made for ' + m;
    });

    var mat = matOf[colour] || '';
    if (matOut) matOut.textContent = mat;
    if (descOut) descOut.textContent = (data.mats && data.mats[mat]) || '';
    if (nameOut) nameOut.textContent = colour;

    var entry = model ? avail[model] : null;
    if (priceOut) priceOut.textContent = entry ? entry.priceFull : '';
    if (selOut) selOut.textContent = entry ? (model + ' · ' + colour) : 'Choose a model';
    setAdd(CTA, entry ? entry.price : '');
    if (addBtn) addBtn.disabled = !entry;

    if (entry) {
      current = entry.media;
      if (shot >= current.length) shot = 0;
      var id = current[shot];
      if (id) setImage(urlFor(id), colour);
      renderThumbs(current);
    } else {
      current = [];
    }

    var many = current.length > 1;
    if (prevBtn) prevBtn.hidden = !many;
    if (nextBtn) nextBtn.hidden = !many;

    var shown = swatches.filter(function (b) { return !b.hidden; }).length;
    if (countOut) countOut.textContent = shown + (shown === 1 ? ' finish' : ' finishes');
  }

  /* ---------- events ---------- */

  root.addEventListener('click', function (e) {
    var th = e.target.closest('[data-sfs-thumb]');
    if (th) { shot = parseInt(th.getAttribute('data-sfs-thumb'), 10) || 0; render(); return; }

    var sw = e.target.closest('[data-sfs-sw]');
    /* A new finish means a new set of shots — start at the render again rather
       than holding an index that means something different now. */
    if (sw) { colour = sw.getAttribute('data-sfs-sw'); shot = 0; render(); return; }

    var md = e.target.closest('[data-sfs-model]');
    if (md && !md.disabled) { model = md.getAttribute('data-sfs-model'); shot = 0; render(); }
  });

  root.addEventListener('pointerover', function (e) {
    var sw = e.target.closest('[data-sfs-sw]');
    if (!sw || sw.dataset.pre) return;
    sw.dataset.pre = '1';
    var pool = byColour[sw.getAttribute('data-sfs-sw')];
    if (!pool) return;
    var entry = pool[model];
    if (!entry) { var k = Object.keys(pool)[0]; entry = k ? pool[k] : null; }
    if (entry && entry.media[0]) { var i = new Image(); i.src = urlFor(entry.media[0]); }
  }, { passive: true });

  filter.addEventListener('change', function () {
    var want = filter.value;
    swatches.forEach(function (b) {
      b.hidden = !inFilter(matOf[b.getAttribute('data-sfs-sw')], want);
    });
    var cur = swatches.filter(function (b) { return b.getAttribute('data-sfs-sw') === colour; })[0];
    if (cur && cur.hidden) {
      var firstVisible = swatches.filter(function (b) { return !b.hidden; })[0];
      if (firstVisible) { colour = firstVisible.getAttribute('data-sfs-sw'); shot = 0; }
    }
    render();
  });

  function say(msg) {
    if (!toast || !toastText) return;
    toastText.textContent = msg;
    toast.classList.add('is-on');
    clearTimeout(say._t);
    say._t = setTimeout(function () { toast.classList.remove('is-on'); }, 2800);
  }

  /* ---------- add to cart ---------- */

  function drawerEl() { return document.querySelector('cart-drawer-component'); }

  function sectionIdOf(el) {
    var s = el && el.closest('[id^="shopify-section-"]');
    return s ? s.id.replace('shopify-section-', '') : null;
  }

  function addToBag(id) {
    var sid = sectionIdOf(drawerEl());
    var body = { items: [{ id: Number(id), quantity: 1 }] };
    if (sid) {
      body.sections = [sid];
      body.sections_url = window.location.pathname;
    }

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function (res) {
        var html = sid && res && res.sections ? res.sections[sid] : null;
        var live = drawerEl();
        var rendered = false;

        if (html && live) {
          try {
            var fresh = new DOMParser()
              .parseFromString(html, 'text/html')
              .querySelector('cart-drawer-component');
            if (fresh) {
              /* Replace the contents, not the element: the custom element stays
                 connected, so open() and its listeners survive the swap. */
              live.innerHTML = fresh.innerHTML;
              rendered = true;
            }
          } catch (e) {}
        }

        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { source: 'suti-finish-studio' }
        }));

        if (rendered && live && typeof live.open === 'function') {
          setTimeout(function () { try { live.open(); } catch (e) {} }, 120);
          return true;
        }
        return false;
      });
  }

  addBtn.addEventListener('click', function () {
    var entry = model && byColour[colour][model];
    if (!entry) return;

    addBtn.disabled = true;
    setAdd('Adding…', '');

    addToBag(entry.id)
      .then(function (opened) { if (!opened) say('Added to cart'); })
      .catch(function () { say('Could not add that — please try again'); })
      .then(function () {
        addBtn.disabled = false;
        setAdd(CTA, entry.price);
      });
  });

  render();
})();
